const TimesActionTypes = {
	GET_AVAILABLE_TIMES: 'GET_AVAILABLE_TIMES',
	UPDATE_SELECTED_ARRIVAL_TIME: 'UPDATE_SELECTED_ARRIVAL_TIME',
	UPDATE_SELECTED_DEPARTURE_TIME: 'UPDATE_SELECTED_DEPARTURE_TIME',
}

export default TimesActionTypes
